import * as types from '../../../types/masters/orderType/orderTypeTypes';
import * as api from '../../../../api/masters/orderType/orderTypeApi';

export const fetchOrderTypes = () => async (dispatch) => {
  dispatch({ type: types.FETCH_ORDER_TYPE_REQUEST });
  try {
    const data = await api.fetchOrderTypes();
    dispatch({ type: types.FETCH_ORDER_TYPE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_ORDER_TYPE_FAILURE, payload: error.message });
  }
};

export const addOrderType = (orderType) => async (dispatch) => {
  try {
    const res = await api.addOrderType(orderType);
    dispatch({ type: types.ADD_ORDER_TYPE_SUCCESS, payload: res });
    dispatch(fetchOrderTypes());
  } catch (error) {
    dispatch({ type: types.ORDER_TYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateOrderType = (id, orderType) => async (dispatch) => {
  try {
    const res = await api.updateOrderType(id, orderType);
    dispatch({ type: types.UPDATE_ORDER_TYPE_SUCCESS, payload: res });
    dispatch(fetchOrderTypes());
  } catch (error) {
    dispatch({ type: types.ORDER_TYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteOrderType = (id) => async (dispatch) => {
  try {
    await api.deleteOrderType(id);
    dispatch({ type: types.DELETE_ORDER_TYPE_SUCCESS, payload: id });
    dispatch(fetchOrderTypes());
  } catch (error) {
    dispatch({ type: types.ORDER_TYPE_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setOrderTypeEdit = (orderType) => ({
  type: types.SET_ORDER_TYPE_EDIT,
  payload: orderType,
});

export const clearOrderTypeEdit = () => ({
  type: types.CLEAR_ORDER_TYPE_EDIT,
}); 